import { json } from '../c-mp/fun/json'
import { Relationship } from '../model/Relationship'

export function getRelationshipName(
	relationship: Relationship | null | undefined,
) {
	switch (relationship) {
		case Relationship.Parditka:
			return `Parditka: róluk szól ez a honlap.`
		case Relationship.Parent:
			return `Szülő: egy Parditka szülője.`
		case Relationship.Child:
			return `Gyermek: egy Parditka gyermeke.`
		case Relationship.Ancestor:
			return `Fölmenő: egy Parditka fölmenője.`
		case Relationship.Descendant:
			return `Leszármazott: egy Parditka leszármazottja.`
		case Relationship.Spouse:
			return `Házastárs: egy Parditka házastársa.`
		case Relationship.Related:
			return `Rokon: a Parditkákhoz... bonyolult szál köti.`
		default:
			throw new Error(json`[tbc3qc] Unknown relationship: ${relationship}`)
	}
}
